<template>
  <div class="outer-container">
    <div class="container">
      <div class="inner-container">
        <h2 class="header-font text-center">Course Outline</h2>

        <div class="grid">
          <div class="">
            <h5>Video Lessons</h5>
            <h2>Part 01</h2>
            <h3>
              Intro and Data Collection - What are Business Intelligence, Data
              Analytics, Machine Learning, and Data Science?
            </h3>
          </div>
          <div class="">
            <ol>
              <li>
                Use case examples Hands-on Case Workshop on Data Collection
                Strategy
              </li>
              <li>
                The scope of Data Analytics
              </li>
              <li>How data connects to the organizations’ strategy</li>
              <li>Different nature of Data for decision making</li>
              <li>Data Collection</li>
              <ul style="padding-left:30px;padding-top:6px">
                <li>Connecting the objective of analysis to collection</li>
                <li>Issues to consider</li>
                <li>Challenges</li>
                <li>Methods of collection</li>
                <li>Biases</li>
              </ul>
            </ol>
          </div>
        </div>
        <hr style="background-color:white; padding:0px 200px" />
        <div class="grid">
          <div class="">
            <h5>Video Lessons</h5>
            <h2>Part 02</h2>
            <h3>
              Storytelling with Data – Visualizations and Dashboards
            </h3>
          </div>
          <div class="">
            <ol>
              <li>What is Storytelling with Data and why do we need it</li>
              <li>Common charts and when to use them</li>
              <li>Descriptive Visualization vs Relational Visualizations</li>
              <li>Dashboards - what they are why we need them</li>
              <li>
                Tool Tutorial - Using Tableau to develop descriptive
                visualizations
              </li>
              <li>
                Tool Tutorial - Using Tableau to create relational
                visualizations
              </li>
              <li>
                Advanced Tableau Hands-on Case Workshop on Data Visualizations
              </li>
            </ol>
          </div>
        </div>
        <hr style="background-color:white; padding:0px 200px" />
        <div class="grid">
          <div class="">
            <h5>Video Lessons</h5>
            <h2>Part 03</h2>
            <h3>
              Methods and Tools of Data Analysis
            </h3>
          </div>
          <div class="">
            <ol>
              <li>Statistics refresher for Data Analytics</li>
              <li>Basic Models of Analysis</li>
              <li>Concepts of Machine Learning</li>
              <li>
                Tool Tutorial - Intro to Orange ML - a basic overview and
                loading data
              </li>
              <li>
                Tool Tutorial - Orange ML - Visualizations and Data
                Preprocessing
              </li>
              <li>Supervised and Unsupervised Learning</li>
              <li>
                Intro to Advanced Machine Learning Hands-on Case Workshop on
                Analytics and Machine Learning Application
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.outer-container {
  padding: 100px 0;
  background-color: #f8f8f9;
}
hr {
  margin: 55px 0;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 55px;
}
.grid h5 {
  font: 700 1rem/1.125rem 'Manrope';
  color: white;
}
.grid h2 {
  font: 700 3.25rem/4rem 'Manrope';
  color: #5b88ed;
}
.grid h3 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: white;
}
.inner-container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 20px 150px;
  background-color: #184dbd;
  padding-bottom: 80px;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: white;
  padding-bottom: 50px;
}
ol li {
  font: 400 1rem/1.125rem 'Manrope';
  color: white;
}
ul li {
  font: 400 1rem/1.125rem 'Manrope';
  color: white;
}
@media only screen and (max-width: 600px) {
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 55px;
  }
  .inner-container {
    max-width: 100%;
    margin: 0 auto;
    padding: 20px 20px;
    background-color: #184dbd;
  }
  ol {
    padding-left: 20px;
  }
  ul {
    padding-left: 30px;
  }
  ol li {
    font: 400 1rem/1.125rem 'Manrope';
    color: white;
  }
  ul li {
    font: 400 1rem/1.125rem 'Manrope';
    color: white;
  }
}
</style>
